export const checkoutUrl = 'https://gym-rythmique-pro.impultienda.ar/checkout'

export const purchaseAnchor = '#offre'

export const productImage =
  'https://cdn.magicpatterns.com/uploads/tMz5oDZ6A7Hz2kHekKfKR6/ChatGPT-Image-29-jul-2026_-07_25_32-p.m..webp'

export const productName = 'GYM RYTHMIQUE PRO™'
